import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class TimeDef {
  key?: string = uuid()
  type: 'time' = 'time'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: TimeOptions = new TimeOptions()
  rules?: Rule[]
}

export class TimeOptions {
  defaultValue?: string | string[] // 根据类型不同而不同
  type?: 'time' | 'timerange' = 'time'
  disabled?: DisabledType = false
  clearable?: boolean = true
  labelWidth?: string | number
  required?: boolean = false
  format?: string
  placeholder?: string
}
